var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"120px","display":"inline-table"}},[_c('datepicker',{staticClass:"date-picker",attrs:{"id":"date-picker","name":"date-picker","format":"yyyy-MM-dd"},on:{"input":function($event){return _vm.updateSelf($event)}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }